import React, {memo, useMemo} from 'react';
import PropTypes from 'prop-types';
import styles from './index.less';
import {useTranslation} from 'react-i18next';
import { Card } from 'antd';

const Contact = ({question}) => {
  const {t} = useTranslation('templates');
  // const {currentAudit} = useAuditData();
  const value = useMemo(() => question?.value, [question?.value]);

  return (
    <Card
      className={styles.templateNumberCard}
      bodyStyle={{padding: '6px'}}
      id={'question-view-' + question?._id}
    >
      <div className="my-3 ml-1 font-bold">
        {t('details.contactInformation')}
      </div>
      {value ? value?.map((item, index) => {
        return (
          <div className="custom-form-big mb-3 ml-1" key={index + item?.email}>
            {item?.name} - {item?.email}
          </div>
        );
      }) : 'N/A' }
    </Card>
  );
};

Contact.propTypes = {
  entity: PropTypes.object,
  question: PropTypes.object,
};
Contact.defaultProps = {
  entity: {},
};

export default memo(Contact);


/**
 * cellRender
 * */
/**
 * This is not a components,
 * it is a function to render the Detail Audit Card components in a detail drawer
 * @param {String} value this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} entity this is the row instance
 * */
export const renderTemplateDetailAuditor = (value, entity) => {
  return (
    <Contact entity={entity}/>
  );
};
